import script from "./EcommerceProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceProductCard.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceProductCard.vue?vue&type=style&index=0&id=279f2848&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279f2848"]])

export default __exports__